import { TBD } from "db/model/match/FsMatch";
import { FsDriverRoster, FsSquadRoster } from "db/model/roster/FsRoster";
import { DriverRoster, SquadRoster } from "model/Roster/Roster";
import { nonEmptyStrings } from "Utility";

export const mapDriverRoster = (
  fsModel: FsDriverRoster | string
): DriverRoster | string => {
  if (typeof fsModel === "string") {
    return fsModel;
  }

  if (!fsModel.driverId) {
    return TBD;
  }

  return {
    disqualified: fsModel.disqualified,
    driverId: fsModel.driverId,
    forfeited: fsModel.forfeited,
  };
};

export const mapSquadRoster = (
  fsModel: FsSquadRoster | string
): SquadRoster | string => {
  if (typeof fsModel === "string") {
    return fsModel;
  }

  if (!fsModel.teamId) {
    return TBD;
  }

  return {
    disqualified: fsModel.disqualified,
    driverIds: nonEmptyStrings(fsModel.driverIds ?? []),
    forfeited: fsModel.forfeited,
    teamId: fsModel.teamId,
  };
};
